/**
 * Sliders
 */

/**
 * AirBnB style dots plugin for KeenSlider
 *
 * @see https://bitbucket.org/evermade/workspace/snippets/y7o6AE
 */
function DotsPlugin (slider, container, props = {}) {
		const defaults = {
			className: 'dots',
			widthPerDot: 12,
		};

		const options = { ...defaults, ...props };

		const dots = document.createElement('div');
		dots.classList.add(options.className);

		const buildDots = ({ options, slides, moveToIdx }) => {

			const numOfDots =
				slides.length - (options?.slides?.perView || 1) + 1;

			dots.innerHTML = '';

			for (let i = 0; i < numOfDots; i++) {
				const button = document.createElement('button');
				button.addEventListener('click', () => moveToIdx(i));
				dots.appendChild(button);
			}
		};

		const setActiveDots = ({ track, slides }) => {
			const {
				details: { rel },
			} = track;
			const buttons = dots.querySelectorAll('button');

			buttons.forEach((button, index) => {
				button.classList.toggle('is-leaving', rel - 2 === index);

				if (rel >= slides.length - 2) {
					button.classList.toggle(
						'is-leaving',
						index >= slides.length - 5 && index < slides.length - 2
					);
				}

				button.classList.toggle('is-entering', rel + 2 === index);

				if (rel < 2) {
					button.classList.toggle(
						'is-entering',
						index >= 2 && index < 5
					);
				}

				button.classList.toggle('is-previous', rel - 1 === index);
				button.classList.toggle('is-active', rel === index);
				button.classList.toggle('is-next', rel + 1 === index);
			});
		};

		const moveTrackToPosition = ({ track, slides }) => {
			const {
				details: { rel },
			} = track;

			let offset = rel;

			if (rel < 2) {
				offset = 2;
			}

			if (rel >= slides.length - 2) {
				offset = slides.length - 3;
			}

			dots.style.transform = `translateX(-${
				offset * options.widthPerDot
			}px)`;
		};

		slider.on('slideChanged', (slider) => {
			setActiveDots(slider);
			moveTrackToPosition(slider);
		});

		slider.on('optionsChanged', (slider) => {
			moveTrackToPosition(slider);
			buildDots(slider);
			setActiveDots(slider);
		});

    container.appendChild(dots);
    moveTrackToPosition(slider);
    buildDots(slider);
    setActiveDots(slider);
}

/**
 * Autoplay plugin for KeenSlider
 */
function AutoPlayPlugin(slider, timeoutAmount) {
  let timeout
  let mouseOver = false;
  function clearNextTimeout() {
    clearTimeout(timeout);
  }
  function nextTimeout() {
    clearTimeout(timeout);
    if (mouseOver) return;
    timeout = setTimeout(() => {
      slider.next();
    }, timeoutAmount);
  }
  slider.container.addEventListener("mouseover", () => {
    mouseOver = true;
    clearNextTimeout();
  })
  slider.container.addEventListener("mouseout", () => {
    mouseOver = false;
    nextTimeout();
  })
  nextTimeout();
  slider.on("dragStarted", clearNextTimeout);
  slider.on("animationEnded", nextTimeout);
  slider.on("updated", nextTimeout);
}

/**
 * Hero carousel for front page
 */
const heroCarousel = () => {

  const heroCarousel = document.querySelector('.js-hero-carousel');
  if (!heroCarousel) {
    return;
  }

  const controls = document.createElement("div");
  controls.classList.add("hero-carousel__controls");
  heroCarousel.appendChild(controls);

  // keen-slider
  const slider = new KeenSlider(heroCarousel, {
    loop: true,
    duration: 10,
    perView: 1,
    defaultAnimation: {
      duration: 750,

    },
    created: (slider) => {
      DotsPlugin(slider, controls);
      AutoPlayPlugin(slider, 7000);
      heroCarousel.classList.remove('is-loading');
    },
    dragStart: () => {
      slider.stop();
    },
    dragEnd: () => {
      slider.start();
    },
  });

};

/**
 * Movie sliders
 */
const movieSliders = () => {
  const sliders = document.querySelectorAll('.js-movie-carousel');
  if (sliders.length === 0) {
    return;
  }
  // loop through sliders
  sliders.forEach((sliderWrapper) => {

    const sliderParentContainer = sliderWrapper.querySelector('.js-movie-carousel-items-container');
    const sliderContainer = sliderWrapper.querySelector('.js-movie-carousel-items');
    if (!sliderContainer || !sliderParentContainer) {
      return;
    }

    // remove slides whsose post id matches current post id in body attribute
    const currentPostId = document.body.getAttribute('data-post-id');
    const slides = sliderContainer.querySelectorAll('.js-movie-carousel-item');
    slides.forEach((slide) => {
      const slidePostId = slide.getAttribute('data-post-id');
      if (slidePostId && slidePostId === currentPostId) {
        slide.remove();
      }
    });

    // create controls
    const controls = document.createElement("div");
    controls.classList.add("movie-carousel__status");
    sliderParentContainer.appendChild(controls);

    const updateButtons = (sliderInstance, sliderWrapper) =>  {
      const prevButton = sliderWrapper.querySelector('.js-movie-carousel-prev');
      const nextButton = sliderWrapper.querySelector('.js-movie-carousel-next');
      if (!prevButton || !nextButton) {
        return;
      }
      const details       = sliderInstance.track.details;
      prevButton.disabled = details.abs - 1 < 0;
      nextButton.disabled = details.abs + 1 > details.maxIdx;
    }

    // mode "snap" if window bigger than 640px otherwise "free"
    // const mode = window.innerWidth > 640 ? "snap" : "free";
    const mode = "snap";

    // keen-slider
    const slider = new KeenSlider(sliderContainer, {
      loop: false,
      mode: mode,
      renderMode: 'performance',
      slides: {
        perView: 1,
        spacing: 12,
      },
      created: (slider) => {
        DotsPlugin(slider, controls);
        sliderContainer.classList.remove('is-loading');
        updateButtons(slider, sliderWrapper);
      },
			slideChanged: (slider) => {
				updateButtons(slider, sliderWrapper);
			},
      breakpoints: {
        "(min-width: 540px)": {
          slides: {
            perView: 2,
            spacing: 14,
          },
        },
        "(min-width: 768px)": {
          slides: {
            perView: 3,
            spacing: 14,
          },
        },
        "(min-width: 1024px)": {
          slides: {
            perView: 3,
            spacing: 14,
          },
        },
        "(min-width: 1280px)": {
          slides: {
            perView: 4,
            spacing: 14,
          },
        },
        "(min-width: 1440px)": {
          slides: {
            perView: 4,
            spacing: 14,
          },
        },
      },
    });

    const prevButton = sliderWrapper.querySelector('.js-movie-carousel-prev');
    const nextButton = sliderWrapper.querySelector('.js-movie-carousel-next');
    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => {
        slider.prev();
      });
      nextButton.addEventListener('click', () => {
        slider.next();
      });
    }


  });
};

document.addEventListener('DOMContentLoaded', () => {
  heroCarousel();
  movieSliders();
});
